import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
interface RouteGuardProps {
  children: React.ReactNode;
  allowedRoles: string[];
}
export function RouteGuard({
  children,
  allowedRoles
}: RouteGuardProps) {
  const {
    role
  } = useAuth();
  // Check if the current user role is allowed to access this route
  if (!allowedRoles.includes(role)) {
    // Redirect to dashboard if user doesn't have permission
    return <Navigate to="/dashboard" replace data-id="element-305" />;
  }
  // If user has permission, render the route's component
  return <>{children}</>;
}